import './style/index.js';

import _Empty from './Empty';

export type { EmptyProps } from './Empty';
export * from './type';

export const Empty = _Empty;
export default Empty;
